import { render, staticRenderFns } from "./attrValue.vue?vue&type=template&id=18f3dcf5&scoped=true&"
import script from "./attrValue.vue?vue&type=script&lang=js&"
export * from "./attrValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f3dcf5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2023/thShop/thShopAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f3dcf5')) {
      api.createRecord('18f3dcf5', component.options)
    } else {
      api.reload('18f3dcf5', component.options)
    }
    module.hot.accept("./attrValue.vue?vue&type=template&id=18f3dcf5&scoped=true&", function () {
      api.rerender('18f3dcf5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/goods/goodsAttribute/attrValue.vue"
export default component.exports